<template>
    <div class="animated fadeIn kgr-grid__cell">
        <div class="kgr-row kgr-region kgr-region--rounded kgr-region--gray">
            <div class="kgr-row">
                {{ $t('So sieht deine Mitgliedsnummer aus') }}:
            </div>
            <kgr-loading v-if="loading" />
            <span
                v-else
                class="kgr-text kgr-text--bold"
            >
                {{ number.toString() }}
            </span>
        </div>
    </div>
</template>

<script>
import Loading from '../../common/Loading';
import MembershipNumber from '../../../js/dto/MembershipNumber';

export default {
    components: {
        'kgr-loading': Loading,
    },
    props: {
        number: {
            type: MembershipNumber,
            required: true,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
}
</script>
